import { ElementFragmentFragment } from "src/graphql/anti-fraud/__generated__/graphql";

export const fakeEntreprise = (siren: string): ElementFragmentFragment => {
  return {
    elements: [],
    configurableType: {
      code: "Entreprise",
      name: "Entreprise",
      __typename: "ElementType",
    },
    schemaElement: {
      name: "Entreprise",
      code: "Entreprise",
      __typename: "SchemaElement",
    },
    __typename: "Element",
    identifiers: [
      {
        schemaIdentifier: {
          code: "SIREN",
          name: "SIREN",
          __typename: "SchemaIdentifier",
        },
        __typename: "Identifier",
        value: siren,
        identifierType: {
          code: "SIREN",
          name: "SIREN",
          __typename: "IdentifierType",
        },
        id: "SWRlbnRpZmllcjo1NGYwZTYxNi0wMWQzLTQ2NmEtODVhZi04ZjYxMGFiZGNjYTQ=",
      },
      {
        schemaIdentifier: {
          code: "RaisonSociale",
          name: "Raison sociale",
          __typename: "SchemaIdentifier",
        },
        __typename: "Identifier",
        value: "L2D",
        identifierType: {
          code: "RaisonSociale",
          name: "Raison sociale",
          __typename: "IdentifierType",
        },
        id: "SWRlbnRpZmllcjo3MWFlOWM4Ny1mNzczLTRlYTItYmY5YS05ZDk5NDg1ODhkNTE=",
      },
      {
        schemaIdentifier: {
          code: "C_Tiers",
          name: "c_tiers",
          __typename: "SchemaIdentifier",
        },
        __typename: "Identifier",
        value: "2444",
        identifierType: {
          code: "C_Tiers",
          name: "C_Tiers",
          __typename: "IdentifierType",
        },
        id: "SWRlbnRpZmllcjo4ZDQwYzRkMC03NzhhLTQ2OTAtYjdmNS05MDk5YWFiMWVkN2U=",
      },
      {
        schemaIdentifier: {
          code: "AdresseSiege",
          name: "Adresse siège",
          __typename: "SchemaIdentifier",
        },
        __typename: "Identifier",
        value: "3 rue Pondichery 75015 Paris France",
        identifierType: {
          code: "Adresse",
          name: "Adresse",
          __typename: "IdentifierType",
        },
        id: "SWRlbnRpZmllcjplMjQyNzczOC1jN2ZhLTQ5OGUtYmMxNC00YzU3NDIwZjYyNmM=",
      },
      {
        schemaIdentifier: {
          code: "Numera",
          name: "Numera",
          __typename: "SchemaIdentifier",
        },
        __typename: "Identifier",
        value: "2333",
        identifierType: {
          code: "Numera",
          name: "Numera",
          __typename: "IdentifierType",
        },
        id: "SWRlbnRpZmllcjplYWM3OTMyZC00ZTk3LTRlYzUtODYwNy03NTI2OGYyZDNkYjc=",
      },
    ],
    id: "RWxlbWVudDphYzMxMmY5Yy0yZjNjLTRmNWMtOTY0OS1kYzc3Y2M3NGZmZDU=",
    properties: [
      {
        property: {
          name: "SIREN",
          mandatory: false,
          __typename: "Property",
          businessType: "String",
          code: "SIREN",
          constraints: [],
          datatype: "String",
          confListCode: null,
        },
        value: siren,
        __typename: "PropertyValue",
      },
      {
        property: {
          name: "Raison sociale",
          mandatory: false,
          __typename: "Property",
          businessType: "String",
          code: "raison_sociale",
          constraints: [],
          datatype: "String",
          confListCode: null,
        },
        value: "L2D",
        __typename: "PropertyValue",
      },
      {
        property: {
          name: "Adresse siège",
          mandatory: false,
          __typename: "Property",
          businessType: "String",
          code: "adresse_siege",
          constraints: [],
          datatype: "String",
          confListCode: null,
        },
        value: "3 rue Pondichery 75015 Paris France",
        __typename: "PropertyValue",
      },
      {
        property: {
          name: "numera",
          mandatory: false,
          __typename: "Property",
          businessType: "String",
          code: "numera",
          confListCode: null,
          constraints: [
            {
              description:
                "Validates that the InputValue, if not empty :\n - is a String that matches the given pattern\n - is a list of String where all elements match the given pattern\n ",
              __typename: "Constraint",
              code: "numera",
              message: "La valeur doit être un nombre entier positif",
              dataType: "String",
              value: "^[1-9]+[0-9]*$",
            },
          ],
          datatype: "String",
        },
        value: "2333",
        __typename: "PropertyValue",
      },
      {
        property: {
          name: "c_tiers",
          mandatory: false,
          __typename: "Property",
          businessType: "String",
          code: "c_tiers",
          constraints: [],
          datatype: "String",
          confListCode: null,
        },
        value: "2444",
        __typename: "PropertyValue",
      },
      {
        property: {
          name: "APE",
          mandatory: false,
          __typename: "Property",
          businessType: "String",
          code: "APE",
          constraints: [],
          datatype: "String",
          confListCode: null,
        },
        value: "Terrains de camping et parcs pour caravanes, véhicules de loisirs",
        __typename: "PropertyValue",
      },
      {
        property: {
          name: "Code APE",
          mandatory: false,
          __typename: "Property",
          businessType: "String",
          code: "CODE_APE",
          constraints: [],
          datatype: "String",
          confListCode: null,
        },
        value: "5530Z",
        __typename: "PropertyValue",
      },
    ],
    name: "Entreprise",
    typeCode: "Entreprise",
  };
};

export const fakeExpertComptable = (
  nom: string,
  prenom: string,
  email: string
): ElementFragmentFragment => {
  return {
    elements: [],
    configurableType: {
      code: "ExpertComptable",
      name: "Expert comptable",
      __typename: "ElementType",
    },
    schemaElement: {
      name: "Expert comptable",
      code: "ExpertComptable",
      __typename: "SchemaElement",
    },
    __typename: "Element",
    identifiers: [
      {
        schemaIdentifier: {
          code: "NomComplet",
          name: "NomComplet",
          __typename: "SchemaIdentifier",
        },
        __typename: "Identifier",
        value: nom.concat(" ", prenom),
        identifierType: {
          code: "NomComplet",
          name: "Nom complet",
          __typename: "IdentifierType",
        },
        id: "SWRlbnRpZmllcjo0YWUzYTlmZS04NmVlLTQyY2EtOWZkMS1lM2QxZjdmOTMzNTM=",
      },
      {
        schemaIdentifier: {
          code: "Email",
          name: "Email",
          __typename: "SchemaIdentifier",
        },
        __typename: "Identifier",
        value: email,
        identifierType: {
          code: "Email",
          name: "Email",
          __typename: "IdentifierType",
        },
        id: "SWRlbnRpZmllcjo5ZGQzZGU0Yy05ZDU1LTRjNzUtOWU2OS01ZDg4ZmRiYzVkY2I=",
      },
    ],
    id: "RWxlbWVudDowNTE3NzUwYS1mYzE2LTRjZTgtYWRiZS1lY2JkZjE1Mzk5NGE=",
    properties: [
      {
        property: {
          name: "Nom",
          mandatory: false,
          __typename: "Property",
          businessType: "String",
          code: "nom",
          constraints: [],
          datatype: "String",
          confListCode: null,
        },
        value: nom,
        __typename: "PropertyValue",
      },
      {
        property: {
          name: "Prénom",
          mandatory: false,
          __typename: "Property",
          businessType: "String",
          code: "prenom",
          constraints: [],
          datatype: "String",
          confListCode: null,
        },
        value: prenom,
        __typename: "PropertyValue",
      },
      {
        property: {
          name: "email",
          mandatory: false,
          __typename: "Property",
          businessType: "String",
          code: "email",
          confListCode: null,
          constraints: [
            {
              description:
                "Validates that the InputValue, if not empty :\n - is a String that matches the given pattern\n - is a list of String where all elements match the given pattern\n ",
              __typename: "Constraint",
              code: "email",
              message: "Veuillez entrer une adresse email valide",
              dataType: "String",
              value:
                '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
            },
          ],
          datatype: "String",
        },
        value: email,
        __typename: "PropertyValue",
      },
    ],
    name: "Expert comptable",
    typeCode: "ExpertComptable",
  };
};

export const fakeRepresentantlegal = (
  nom: string,
  prenom: string,
  email: string
): ElementFragmentFragment => {
  return {
    elements: [],
    configurableType: {
      code: "RepresentantLegal",
      name: "Representant légal",
      __typename: "ElementType",
    },
    schemaElement: {
      name: "Représentant Légal",
      code: "RepresentantLegal",
      __typename: "SchemaElement",
    },
    __typename: "Element",
    identifiers: [
      {
        schemaIdentifier: {
          code: "Email",
          name: "Email",
          __typename: "SchemaIdentifier",
        },
        __typename: "Identifier",
        value: email,
        identifierType: {
          code: "Email",
          name: "Email",
          __typename: "IdentifierType",
        },
        id: "SWRlbnRpZmllcjozMTdhOTkxYy0xOWMxLTQ4MmYtODdiNC0wZDljNTg1M2UyNzg=",
      },
      {
        schemaIdentifier: {
          code: "Telephone",
          name: "Téléphone",
          __typename: "SchemaIdentifier",
        },
        __typename: "Identifier",
        value: "+33600007009",
        identifierType: {
          code: "Telephone",
          name: "Téléphone",
          __typename: "IdentifierType",
        },
        id: "SWRlbnRpZmllcjo1OTNhNzhhNC05ZjY4LTQzZDUtOWFlZS1mOWExOWViMGM3YmM=",
      },
      {
        schemaIdentifier: {
          code: "NomComplet",
          name: "NomComplet",
          __typename: "SchemaIdentifier",
        },
        __typename: "Identifier",
        value: nom.concat(" ", prenom),
        identifierType: {
          code: "NomComplet",
          name: "Nom complet",
          __typename: "IdentifierType",
        },
        id: "SWRlbnRpZmllcjpmZjgyNzhiMy0xMTdkLTQyOTAtOGFhMi0xNjIxNjgyNDIxOTI=",
      },
    ],
    id: "RWxlbWVudDpjNDg0MjMxOC03ZWY5LTQ0ODMtYmNkZS0yYjhkZDkzNTg0Yjk=",
    properties: [
      {
        property: {
          name: "Nom",
          mandatory: false,
          __typename: "Property",
          businessType: "String",
          code: "nom",
          constraints: [],
          datatype: "String",
          confListCode: null,
        },
        value: nom,
        __typename: "PropertyValue",
      },
      {
        property: {
          name: "Prénom",
          mandatory: false,
          __typename: "Property",
          businessType: "String",
          code: "prenom",
          constraints: [],
          datatype: "String",
          confListCode: null,
        },
        value: prenom,
        __typename: "PropertyValue",
      },
      {
        property: {
          name: "Email",
          mandatory: false,
          __typename: "Property",
          businessType: "String",
          code: "email",
          confListCode: null,
          constraints: [
            {
              description:
                "Validates that the InputValue, if not empty :\n - is a String that matches the given pattern\n - is a list of String where all elements match the given pattern\n ",
              __typename: "Constraint",
              code: "email",
              message: "Veuillez entrer une adresse email valide",
              dataType: "String",
              value:
                '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
            },
          ],
          datatype: "String",
        },
        value: email,
        __typename: "PropertyValue",
      },
      {
        property: {
          name: "Téléphone",
          mandatory: false,
          __typename: "Property",
          businessType: "String",
          code: "telephone",
          confListCode: null,
          constraints: [
            {
              description:
                "Validates that the InputValue, if not empty :\n - is a String that matches the given pattern\n - is a list of String where all elements match the given pattern\n ",
              __typename: "Constraint",
              code: "tel",
              message:
                "Le numéro de téléphone doit être entré au format international (exemple +33123456789)",
              dataType: "String",
              value: "^\\+[1-9]{1}[0-9]{3,14}$",
            },
          ],
          datatype: "String",
        },
        value: "+33600007009",
        __typename: "PropertyValue",
      },
    ],
    name: "Représentant Légal",
    typeCode: "RepresentantLegal",
  };
};

export const fakePaperDocument = (siren: string): ElementFragmentFragment => {
  return {
    elements: [],
    configurableType: {
      code: "PappersFicheEntreprise",
      name: "Fiche entreprise Pappers",
      __typename: "ElementType",
    },
    schemaElement: {
      name: "Fiche entreprise Pappers",
      code: "PappersFicheEntreprise",
      __typename: "SchemaElement",
    },
    __typename: "Element",
    identifiers: [
      {
        schemaIdentifier: {
          code: "RaisonSociale",
          name: "Raison Sociale",
          __typename: "SchemaIdentifier",
        },
        __typename: "Identifier",
        value: "not Post Case Test",
        identifierType: {
          code: "RaisonSociale",
          name: "Raison sociale",
          __typename: "IdentifierType",
        },
        id: "SWRlbnRpZmllcjo0MjllMTk4OS03YjU5LTQ0ZWQtOTNlMC05NjE4OWI3ZTFlNzA=",
      },
      {
        schemaIdentifier: {
          code: "SIREN",
          name: "SIREN",
          __typename: "SchemaIdentifier",
        },
        __typename: "Identifier",
        value: siren,
        identifierType: {
          code: "SIREN",
          name: "SIREN",
          __typename: "IdentifierType",
        },
        id: "SWRlbnRpZmllcjo1NGYwZTYxNi0wMWQzLTQ2NmEtODVhZi04ZjYxMGFiZGNjYTQ=",
      },
    ],
    id: "RWxlbWVudDplZDczOWVhYy05NWRiLTQ3NGQtYjM4MS0zNGFjMDM0ZTA1Zjk=",
    properties: [
      {
        property: {
          name: "SIREN",
          mandatory: false,
          __typename: "Property",
          businessType: "String",
          code: "pfe_siren",
          constraints: [],
          datatype: "String",
          confListCode: null,
        },
        value: siren,
        __typename: "PropertyValue",
      },
      {
        property: {
          name: "Nom de l'entreprise",
          mandatory: false,
          __typename: "Property",
          businessType: "String",
          code: "pfe_nom_entreprise",
          constraints: [],
          datatype: "String",
          confListCode: null,
        },
        value: "not Post Case Test",
        __typename: "PropertyValue",
      },
      {
        property: {
          name: "Code NAF",
          mandatory: false,
          __typename: "Property",
          businessType: "String",
          code: "pfe_code_naf",
          constraints: [],
          datatype: "String",
          confListCode: null,
        },
        value: "70.10Z",
        __typename: "PropertyValue",
      },
      {
        property: {
          name: "Libellé code NAF",
          mandatory: false,
          __typename: "Property",
          businessType: "String",
          code: "pfe_libelle_code_naf",
          constraints: [],
          datatype: "String",
          confListCode: null,
        },
        value: "Activités des sièges sociaux",
        __typename: "PropertyValue",
      },
      {
        property: {
          name: "Procédure collective existe",
          mandatory: false,
          __typename: "Property",
          businessType: "Boolean",
          code: "pfe_procedure_collective_existe",
          constraints: [],
          datatype: "Boolean",
          confListCode: null,
        },
        value: "false",
        __typename: "PropertyValue",
      },
      {
        property: {
          name: "Procédure collective en cours",
          mandatory: false,
          __typename: "Property",
          businessType: "Boolean",
          code: "pfe_procedure_collective_en_cours",
          constraints: [],
          datatype: "Boolean",
          confListCode: null,
        },
        value: "false",
        __typename: "PropertyValue",
      },
      {
        property: {
          name: "Entreprise cessée",
          mandatory: false,
          __typename: "Property",
          businessType: "Boolean",
          code: "pfe_entreprise_cessee",
          constraints: [],
          datatype: "Boolean",
          confListCode: null,
        },
        value: "false",
        __typename: "PropertyValue",
      },
    ],
    name: "Fiche entreprise Pappers",
    typeCode: "PappersFicheEntreprise",
  };
};
